export const codeMdr = 1;
export const codeTor = 2;
export const codeFeePerTransaction = 3;
export const codeAnnualFee = 4;
export const codeMembershipFee = 5;
export const codeSaleDeadline = 6;
